import { Engine, Scene, ScreenElement, Sprite } from "excalibur";
import { Resources } from "../resources";
import { TitleScene } from "./title";

export class LoseScene extends Scene {
    public onInitialize(engine: Engine) {
        const loseSprite = new Sprite({
            image: Resources.lose,
        })

        const spriteAspectRatio = loseSprite.width / loseSprite.height;

        if (engine.drawWidth / engine.drawHeight > spriteAspectRatio) {
            loseSprite.destSize = {
                width: engine.drawWidth,
                height: engine.drawWidth / spriteAspectRatio,
            }
        } else {
            loseSprite.destSize = {
                width: engine.drawHeight * spriteAspectRatio,
                height: engine.drawHeight,
            }
        }

        const lose  = new ScreenElement({
            x: engine.drawWidth / 2 - loseSprite.destSize.width / 2,
            y: engine.drawHeight / 2 - loseSprite.destSize.height / 2,
            width: loseSprite.destSize.width,
            height: loseSprite.destSize.height,
        });

        lose.graphics.use(loseSprite);

        lose.on('pointerup', () => {
            this.engine.removeScene(this);
            this.engine.addScene('title', new TitleScene());
            this.engine.goToScene('title');
        });

        this.add(lose);
        
        Resources.youLose.play().then(() => Resources.youLose.stop())
    }
}